import {
  userConsentsAccepted,
  getConsentResult,
  getConsents,
  getUserConsentForGV,
} from "./consent/otto.js";
import { exactagScope, exactagState } from "./core/utils.js";
import { onLoad } from "@otto-ec/global-resources/dom";
import { eventLoader } from "@otto-ec/global-resources/event-loader";
import {
  initializeExactag,
  executeExactagHandler,
  executeExactagProcess,
  submitToExactag,
} from "./core/execute.js";
import { campaignId } from "./consent/partner.js";
import { varnishData } from "./collect/varnish.js";
import {
  exactagFlags,
  setExactagFlags,
  getExactagFlags,
} from "./observability/testFlags.js";
import { registerVerticalDataCallback } from "./collect/verticals.js";
import { exactagData, getExactagData, updateExactagData } from "./core/data.js";
import {
  enableBenchmark,
  getBenchmarkResult,
} from "./observability/benchmark.js";
import { consentChanged } from "@otto-ec/eprivacy-cmp";

/*                                                                       */
import "./libext/cycle.js";
import "./libext/exactag.js";
import { logger } from "@otto-ec/global-resources/debug";

/*                       */
import { appendCriteoData } from "./onex.js";

const log = exactagScope.scope("module");

log.info("Constructing exactag Object");
window.lhotse = Object.assign(window.lhotse ?? {}, {
  exactag: {
    /*                                              */
    get varnish() {
      return varnishData;
    },

    get centralComplete() {
      return exactagState.centralComplete;
    },
    get first() {
      return exactagState.isFirstRun;
    },

    get campaignId() {
      return campaignId;
    },

    getConsents,
    getConsentResult,
    userConsentsAccepted,
    getUserConsentForGV,
    executeExactagProcess,
    getExactagFlags,
    setExactagFlags,
    registerVerticalDataCallback,

    /*         */
    hasConsent: getUserConsentForGV,
    register: registerVerticalDataCallback,
    track: executeExactagProcess,

    get data() {
      return exactagData;
    },
    /*                  */
    set data(_) {
      logger("exactag.deprecated").warn(
        "exactag.data is deprecated. Use apropriate nexus api instead."
      );
    },
    get execute() {
      return userConsentsAccepted();
    },
    get centralFinished() {
      return exactagState.centralComplete;
    },
    get testMode() {
      return exactagFlags.testMode[0];
    },
    set testMode(value: boolean) {
      exactagFlags.testMode[0] = value;
    },
    get QAMode() {
      return exactagFlags.QAMode[0];
    },
    set QAMode(value: boolean) {
      exactagFlags.QAMode[0] = value;
    },
    get OptOutMode() {
      return exactagFlags.OptOutMode[0];
    },
    set OptOutMode(value: boolean) {
      exactagFlags.OptOutMode[0] = value;
    },
  },
});

log.info("Constructing asynchronous, exactag namespace");
otto.exactag.assignNamespace({
  registerVerticalDataCallback,
  userConsentsAccepted,
  submitToExactag,
  enableBenchmark,
  getBenchmarkResult,
  getExactagData,
  updateExactagData,
});

log.info("Subscribe to onLoad event");
onLoad.sub(executeExactagHandler);

/*                                                     */
log.info("Subscribe to eprivacy consent changed event");
consentChanged.sub(executeExactagHandler);

log.info("Subscribe to event loader for all preload scripts");
eventLoader.onAllPreloadScriptsLoaded(11, initializeExactag);

/*                                                   */
appendCriteoData();
